import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import Icon from '../../../atoms/Icon'
import FlexRow from '../../../molecules/FlexRow'
import ClientBalance from '../../ClientCardsViewV2/ClientCardView/ClientCard/ClientCardFooter/ClientBalance'
import { ICON_NAMES } from '../../../../constants'

const useStyles = makeStyles(() => ({
  footer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-start'
  }
}))

const TopClientFooter = ({
  balance,
  taskCount,
  nextMeetingDate,
  balanceIcon,
  taskIcon,
  meetingIcon
}) => {
  const classes = useStyles()

  const hasBalance = balance !== undefined && balance !== null
  const hasTaskCount = taskCount !== undefined && taskCount !== null
  const hasMeeting = nextMeetingDate !== undefined

  return (
    <div className={classes.footer}>
      {hasBalance && (
        <FlexRow>
          <Icon name={balanceIcon} customSize='1rem' color='#74808F' />
          <ClientBalance
            {...balance}
          />
        </FlexRow>
      )}
      {hasTaskCount && (
        <FlexRow>
          <Icon name={taskIcon} customSize='1rem' color='#74808F' />
          {`${taskCount} ${taskCount === 1 ? 'task' : 'tasks'}`}
        </FlexRow>
      )}
      {hasMeeting && (
        <FlexRow>
          <Icon name={meetingIcon} customSize='1rem' color='#74808F' />
          {nextMeetingDate || 'None'}
        </FlexRow>
      )}
    </div>
  )
}

TopClientFooter.propTypes = {
  balance: PropTypes.shape({
    endingValue: PropTypes.number,
    balanceChangeStatus: PropTypes.string
  }),
  taskCount: PropTypes.number,
  nextMeetingDate: PropTypes.string,
  balanceIcon: PropTypes.string,
  taskIcon: PropTypes.string,
  meetingIcon: PropTypes.string
}

TopClientFooter.defaultProps = {
  balance: undefined,
  taskCount: undefined,
  nextMeetingDate: undefined,
  balanceIcon: ICON_NAMES.moneyBag,
  taskIcon: ICON_NAMES.task,
  meetingIcon: ICON_NAMES.calendar
}

export default TopClientFooter
